<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="1300px"
    :innerScroll="false"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
    :loading="loadingButtom"
  >
    <div class="content">
      <el-form ref="addForm" :model="addForm" :rules="rules" size="small" inline v-loading="loading" style="overflow: hidden">
        <div v-for="(item, index) in addForm.updateList" :key="index">
          <el-form-item label="品类细分:" :prop="'updateList.' + index + '.category'" :rules="rules.category">
            <el-select v-model="item.category" filterable @change="categoryChange(item.category, index)">
              <el-option v-for="item in categoryList" :label="item.optionValue" :key="item.optionValue" :value="item.optionValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="大型号:" :prop="'updateList.' + index + '.bigModel'" :rules="rules.bigModel">
            <el-select v-model="item.bigModel" filterable>
              <el-option v-for="data in item.bigModelList" :label="data.bigModel" :key="data.bigModel" :value="data.bigModel"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售额差异(万):" :prop="'updateList.' + index + '.saleAmountDiff'" :rules="rules.saleAmountDiff">
            <el-input v-model="item.saleAmountDiff" @input="buyPriceInput('saleAmountDiff', index)"></el-input>
          </el-form-item>
          <el-form-item label="备注:" :prop="'updateList.' + index + '.remark'">
            <el-input v-model="item.remark" type="textarea" :rows="1"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button size="mini" type="text" @click="addRow(index)">新增</el-button>
            <el-button size="mini" type="text" style="color: red" v-if="index > 0 || addForm.updateList.length > 1" @click="delRow(index)">删除</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </q-dialog>
</template>

<script>
import moment from "moment";
import axios from "@/utils/axiosInstance";
export default {
  name: "CRUDEdit",
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "新增";
    },
  },
  data() {
    return {
      loading: false,
      addForm: {
        updateList: [{ category: "", bigModel: "", saleAmountDiff: "", bigModelList: [], remark: "" }],
      },
      categoryList: [],
      rules: {
        category: [{ required: true, message: "不能为空", trigger: "change" }],
        bigModel: [{ required: true, message: "不能为空", trigger: "change" }],
        saleAmountDiff: [{ required: true, message: "不能为空", trigger: "change" }],
      },
      loadingButtom: false,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loadingButtom = true;
        let data = {
          dataList: this.addForm.updateList,
        };
        this.$q.product
          .categoryBigModelConfigSave({ data: data })
          .then((res) => {
            if (res.code == 200) {
              let text = this.title + "成功";
              this.$message.success(text);
              this.isVisible = false;
              this.$emit("success");
            }
          })
          .finally((_) => {
            this.loadingButtom = false;
          });
      });
    },
    async init() {},
    addRow(index) {
      this.addForm.updateList.splice(index + 1, 0, { category: "", bigModel: "", saleAmountDiff: "", bigModelList: [], remark: "" });
    },
    delRow(index) {
      this.addForm.updateList.splice(index, 1);
    },
    getOptionTypes() {
      this.loading = true;
      this.$q.product
        .optionTypes()
        .then((res) => {
          this.categoryList = res.data.categoryList;
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    categoryChange(val, index) {
      this.addForm.updateList[index].bigModel = "";
      let data = { ...this.currencyForm };
      data.reportCode = "searchBigModelByCategory";
      data.param = {
        category: val,
      };
      axios.post(`/ec-pc-api/custom/reports/data/searchBigModelByCategory`, data).then((res) => {
        if (res.code == 200) {
          this.addForm.updateList[index].bigModelList = res.data.list;
        }
      });
    },
    //只能输入正数并小数点保留两位
    buyPriceInput(name, index) {
      var price = "" + this.addForm.updateList[index][name];
      this.addForm.updateList[index][name] = price.match(/^\d*(\.?\d{0,2})/g)[0];
    },
  },
  created() {
    this.getOptionTypes();
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-date-editor, >>> .el-select, >>> .el-input {
  width: 170px !important;
}
.content {
  max-height: 70vh
  overflow-y: auto
  text-align: center
}

>>> .el-dialog {
	margin-top: 50px !important
}
</style>
